<template>
    <Menu
        theme="light"
        width="auto"
        :open-names="openNames"
        :active-name="activeName"
        class="main-menu left-menu"
        ref="menu"
        @on-open-change="openChange"
    >
        <template v-for="parent in routers">
            <Submenu
                v-if="parent.children && parent.children.length > 0"
                :name="parent.resourceId"
                :key="parent.resourceId"
            >
                <template slot="title">
                    <div style="font-size: 15px">
                        <IconFont
                            :icon="parent.icon"
                            :path="parent.path"
                        ></IconFont>
                        {{ parent.resourceName || parent.title }}
                    </div>
                </template>
                <template
                    v-for="(parentOne, parentOneIndex) in parent.children"
                >
                    <MenuItem
                        :name="parentOne.resourceId"
                        v-if="
                            !parentOne.hide &&
                            !parentOne.children.filter(
                                (f) => f.resourceType === '2'
                            ).length > 0
                        "
                        :key="parentOne.resourceId"
                        :to="parentOne.path"
                        :replace="true"
                    >
                        <span class="menu-title">{{
                            parentOne.title ||
                            parentOne.meta.title ||
                            parentOne.resourceName
                        }}</span>
                    </MenuItem>
                    <Submenu
                        :name="parentOne.resourceId"
                        :key="parentOne.resourceId + parentOneIndex"
                        v-if="
                            parentOne.children.filter(
                                (f) => f.resourceType === '2'
                            ).length > 0
                        "
                    >
                        <template
                            slot="title"
                            style="padding-left: 51px !important"
                            >{{
                                parentOne.title ||
                                parentOne.meta.title ||
                                parentOne.resourceName
                            }}</template
                        >
                        <MenuItem
                            :name="parenTwo.resourceId"
                            v-for="parenTwo in parentOne.children"
                            v-show="!parenTwo.hide || !parenTwo.children"
                            :key="parenTwo.resourceId"
                            :to="parenTwo.path"
                            :replace="true"
                        >
                            <span class="menu-title">{{
                                parenTwo.title ||
                                parenTwo.meta.title ||
                                parenTwo.resourceName
                            }}</span>
                        </MenuItem>
                    </Submenu>
                </template>
            </Submenu>
            <MenuItem
                :name="parent.resourceId"
                v-if="
                    !parent.hide &&
                    (!parent.children || parent.children.length < 1)
                "
                :key="parent.resourceId"
                :to="parent.path"
                :replace="true"
            >
                <div style="font-size: 15px">
                    <IconFont
                        :icon="parent.icon"
                        :path="parent.path"
                    ></IconFont>
                    {{ parent.resourceName || parent.title }}
                </div>
            </MenuItem>
        </template>
    </Menu>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'MainMenu',
    computed: {
        ...mapGetters({
            routers: 'comon/routers',
            menuBtns: 'comon/menuBtns',
        }),
    },
    data() {
        return {
            openNames: [],
            activeName: '',
            openNameList: [],
        };
    },
    watch: {
        '$route.path': function (val) {
            this.setMenu(val);
        },
    },
    created() {
        this.setMenu();
    },
    methods: {
        openChange(list) {
            this.openNameList = list;
        },
        setMenu(value) {
            let val = value || this.$route.path;
            setTimeout(() => {
                if (val.indexOf('edit') > -1)
                    val = val.substring(0, val.length - 5) + '-list';
                this.openNames = this.openNameList;
                this.routers.forEach((item) => {
                    if (item.children.length > 0) {
                        item.children
                            .filter(
                                (f) =>
                                    f.resourceType === '2' ||
                                    f.resourceType === '1'
                            )
                            .forEach((child) => {
                                if (
                                    child.path === val &&
                                    child.children.filter(
                                        (f) => f.resourceType === '2'
                                    ).length < 1
                                ) {
                                    this.openNames.push(item.resourceId);
                                    this.activeName = child.resourceId;
                                } else if (
                                    child.children.filter(
                                        (f) => f.resourceType === '2'
                                    ).length > 0
                                ) {
                                    const grandson = child.children
                                        .filter((f) => f.resourceType === '2')
                                        .find((f) => f.path === val);
                                    if (grandson) {
                                        this.openNames.push(
                                            ...[
                                                item.resourceId,
                                                child.resourceId,
                                            ]
                                        );
                                        this.activeName = grandson.resourceId;
                                    }
                                }
                            });
                    }
                });
                this.$nextTick(() => {
                    this.openNames = [...new Set(this.openNameList)];
                    if (this.openNames.length > 0) {
                        this.$refs.menu.updateOpened();
                        this.$refs.menu.updateActiveName();
                    }
                });
            }, 300);
        },
    },
};
</script>

<style scoped></style>
